import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddGuarantorComponent } from '../../../masters/tenant-guarantor/add-guarantor/add-guarantor.component';
import { AddTenantComponent } from '../../../masters/tenant-master/add-tenant/add-tenant.component';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { SharedPipesModule } from '../../shared-pipes/shared-pipes.module';

@NgModule({
  declarations: [AddGuarantorComponent, AddTenantComponent],
  imports: [
    CommonModule,
    // HttpClientModule,
    FormsModule,
    ModalModule.forRoot(),
    TooltipModule.forRoot(),
    MatFormFieldModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
    SharedPipesModule    
  ],
  exports: [AddTenantComponent, AddGuarantorComponent],
})
export class SharedMasterModule {}
